const translations = {
  "rewards.header.pre-title": "Offers",
  "rewards.header.title": "All Offers",
  "rewards.header.no-results": "No results found",
  "rewards.header.search-results": "{numResults} offers found",
  "rewards.header.loading": "Searching...",
  "rewards.search": "Search by name",
  "rewards.toggle.near": "Show near me",
  "rewards.alert.location": "Please enable browser location services to see offers near you!",
  "rewards.location.title": "Redeem offer in these location",
  "rewards.no.results": "No Results Found",
  "rewards.search.results": "Search results for",
  "rewards.clear.search": "Clear search",
}

export default translations;